import { z } from 'zod';

export const imeiSchema = z
  .string({ message: 'IMEI must be a string' })
  .regex(/^\d+$/, { message: 'IMEI must contain digits only' })
  .min(15, { message: 'IMEI must be 15-17 characters long' })
  .max(17, { message: 'IMEI must be at max 17 characters long' });

export const companyNameSchema = z
  .string({
    required_error: 'Company name is required',
  })
  .trim()
  .min(1, 'Company name is required')
  .max(50, 'Company name cannot exceed 50 characters')
  .regex(
    /^[a-zA-Z0-9\s,.\-&_]+$/,
    'Company name can only include letters, numbers, commas (,), dashes (-), ampersands (&), underscores (_), and periods (.)'
  );

export const phoneNumberSchema = z
  .string({ message: 'Phone number must be a string' })
  .trim()
  .min(1, { message: 'Phone number is required' })
  .refine((val) => /^\d{10,15}$/.test(val.replace(/\D/g, '')), {
    message: 'Phone number must be at least 10 digits long',
  });

export const countryCodeSchema = z
  .string({ message: 'Country code is required' })
  .regex(/^\d{1,4}$/, { message: 'Country code must be digits only' });
